"use client"

import { OneTagScript } from "@/components/pixel-scripts/one-tag-scripts/one-tag-script"
import { usePixelInjectionPermissionSnai } from "@/hooks/use-pixel-injection-permission"
import useSignupRequestStore from "@/store/signup-request-store"

export function OnetagSignupStartPixelScriptSnai() {
  const canInjectPixels = usePixelInjectionPermissionSnai()
  const { data } = useSignupRequestStore()

  if (!canInjectPixels) return null

  return (
    <OneTagScript
      segmentId="121517"
      scriptId="DT9-signup-start"
      netreferId={data.fromPdv ? "affiliation" : undefined}
    />
  )
}
